module.exports = __webpack_public_path__ + "media/stylesheets/images/SAReye-Main-OFFICIAL-RGB-transparent-115e73e422c198fd70493fcbe0af3dde.png";